// extracted by mini-css-extract-plugin
export var details = "_ga-0";
export var inspectorPopover = "_ga-1";